var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showtext),expression:"showtext"}],staticClass:"font-weight-bold black--text"},[_vm._v(" "+_vm._s(_vm.TextMain)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }